import { observer } from 'mobx-react-lite'
import { VisuallyHidden } from '@react-aria/visually-hidden'
import Styles from '../../BlogMetadata.module.scss'
import { BlogMetadataCompositionReturn } from '../../hooks/useBlogMetadataComposition'
import {
  BlogMetadataHeader,
  BlogMetadataFormFields,
  BlogMetadataIntegrationSection,
  BlogMetadataImageSection,
  BlogMetadataCategoriesSection,
} from '..'

export const GoHighLevelBlogMetadataLayout = observer(
  ({ integrationInfo, states, handlers, refs }: BlogMetadataCompositionReturn) => {
    return (
      <div className={Styles.container} data-testid="blog-metadata-v2">
        <VisuallyHidden>
          <input
            aria-label="Upload featured image"
            ref={refs.fileInputRef}
            type="file"
            multiple={false}
            onChange={handlers.imageHandlers.handleFileInputChange}
            accept="image/*"
          />
        </VisuallyHidden>

        <BlogMetadataHeader blogIntegrationsCount={integrationInfo.blogIntegrationsCount} />

        <BlogMetadataFormFields
          formState={states.formState}
          handlers={handlers.enhancedFormHandlers}
          shouldShowAuthorField={false}
        />

        <BlogMetadataIntegrationSection
          integrationState={states.integrationState}
          handlers={handlers.enhancedIntegrationHandlers}
          isPostPublished={integrationInfo.isPostPublished}
        />

        <BlogMetadataImageSection imagesState={states.imageState} handlers={handlers.imageHandlers} />

        <BlogMetadataCategoriesSection
          categoriesState={states.categoriesState}
          categoriesHandlers={handlers.enhancedCategoriesHandlers}
          tagsState={states.tagsState}
          tagsHandlers={handlers.enhancedTagsHandlers}
          useCategoryDropdown={states.integrationState.useCategoryDropdown}
          availableCategories={states.integrationState.availableCategories}
          allowAddingCategories={states.integrationState.allowAddingCategories}
        />
      </div>
    )
  },
)
